<script>
import core from '@/core';

export default {
  components: {
  },
  data: () => ({
    core,
    show: false,
  }),
  mounted() {
    window.app = this;
    core
      .init()
      .finally(() => {
        const loader = document.querySelector('#layout-preloading');
        if (loader) {
          document.body.removeChild(loader);
        }
        this.show = true;
      });
  },
};
</script>
<template>
  <router-view v-if="show"></router-view>
</template>
<style lang="scss">
  body {
    font-family: Roboto, sans-serif;
  }

  * {
    box-sizing: border-box;
  }
</style>
